export function inspectionObjectionNotice2026() {
return [   // Release 2025-12-19 10:11:36
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 197.96,
   left: 460.08,
   width: 125.04,
   height: 11.542
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 210.76,
   left: 298.36,
   width: 130.08,
   height: 11.542
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.571,
   left: 50.5273,
   width: 493.2327,
   height: 12.196
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 241.76,
   left: 68.7564,
   width: 477.0436,
   height: 11.542
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 271.76,
   left: 50.5273,
   width: 483.2727,
   height: 11.542
}
,
{
   page: 0,
   name: "Inspection Objections", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 345.601,
   left: 40.5819,
   width: 553.3301,
   height: 416.2977
}
,
{
   page: 1,
   name: "Inspection Objections 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 29.324,
   left: 38.2253,
   width: 547.7007,
   height: 281.199
}
,
{
   page: 1,
   name: "Additional Number of Pages", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 311.12,
   left: 203.64,
   width: 53.04,
   height: 11.324
}
,
{
   page: 1,
   name: "Radiobutton InspectionReportProvided Is", 
   isText: false,
   type: "checkbox",
   top: 413.675,
   left: 165.601,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobutton InspectionReportProvided Is Not", 
   isText: false,
   type: "checkbox",
   top: 413.02,
   left: 202.91,
   width: 10.08,
   height: 10.08
}
] }
